/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MakeupChangeRequest
 */
export interface MakeupChangeRequest {
    /**
     * 
     * @type {Date}
     * @memberof MakeupChangeRequest
     */
    suggestedDate: Date;
    /**
     * 
     * @type {string}
     * @memberof MakeupChangeRequest
     */
    suggestedStartTime: string;
    /**
     * 
     * @type {string}
     * @memberof MakeupChangeRequest
     */
    suggestedEndTime: string;
    /**
     * 
     * @type {string}
     * @memberof MakeupChangeRequest
     */
    reviewNote: string | null;
}

/**
 * Check if a given object implements the MakeupChangeRequest interface.
 */
export function instanceOfMakeupChangeRequest(value: object): value is MakeupChangeRequest {
    if (!('suggestedDate' in value) || value['suggestedDate'] === undefined) return false;
    if (!('suggestedStartTime' in value) || value['suggestedStartTime'] === undefined) return false;
    if (!('suggestedEndTime' in value) || value['suggestedEndTime'] === undefined) return false;
    if (!('reviewNote' in value) || value['reviewNote'] === undefined) return false;
    return true;
}

export function MakeupChangeRequestFromJSON(json: any): MakeupChangeRequest {
    return MakeupChangeRequestFromJSONTyped(json, false);
}

export function MakeupChangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MakeupChangeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestedDate': (new Date(json['suggestedDate'])),
        'suggestedStartTime': json['suggestedStartTime'],
        'suggestedEndTime': json['suggestedEndTime'],
        'reviewNote': json['reviewNote'],
    };
}

export function MakeupChangeRequestToJSON(json: any): MakeupChangeRequest {
    return MakeupChangeRequestToJSONTyped(json, false);
}

export function MakeupChangeRequestToJSONTyped(value?: MakeupChangeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'suggestedDate': value['suggestedDate'].toISOString().substring(0,10),
        'suggestedStartTime': value['suggestedStartTime'],
        'suggestedEndTime': value['suggestedEndTime'],
        'reviewNote': value['reviewNote'],
    };
}

